export default ({id, isPhoto, previewUrl}) => ({
    id,
    previewUrl,
    isPhoto,
    playing: false,
    get urlIsFilled() {
        return Boolean(this.previewUrl);
    },
    handleSyncPreviewUrl(event) {
        if (this.isPhoto) {
            return;
        }

        const parentId = event.detail.parentId;

        if (parentId === this.id && this.urlIsFilled) {
            this.$dispatch('set-preview-url', {parentId: this.id, previewUrl: this.previewUrl});
        }
    },
    handleVideoPreviewPlaying(event) {
        if (event.detail.parentId === this.id) {
            this.playing = event.detail.playing;
        }
    }
})
